<!--
 * @Description: 人员详情面板组件
 * @Author: gaohc
 * @Date: 2022-11-28 16:43:52
-->
<template>
  <div class="body">
     <el-dialog class="dialog-attendant" width="1200px" title="人员详情" :visible.sync="visible" 
       :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
       <attendant-baseinfo v-if="attendantDo.attendant" :baseInfo="attendantDo.attendant" />
       <attendant-certinfo :thisPlatformCertificateList="attendantDo.thisPlatformCertificateList"
        :outerPlatformCertificateList="attendantDo.outerPlatformCertificateList" 
        v-if="attendantDo.attendant && attendantDo.attendant.reviewStatus != 11"
        @handle-sync-data="handleSyncCertData" @handle-get-sync-history="handleSeeSycnHistoyrData"
        :syncHistoryData="syncHistoryData" />
     </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import AttendantBaseInfo from './attendantdetails/AttendantBaseInfo.vue'
import AttendantCertInfo from './attendantdetails/AttendantCertInfo.vue'

export default {
  name: 'AttendantDetailsDialog',
  props: ["visible", "attendantId"],

  components: {
    'attendant-baseinfo': AttendantBaseInfo,
    'attendant-certinfo': AttendantCertInfo
  },

  data() {
    return {
      attendantDo: {},
      syncHistoryData: []
    }
  },
  
  methods: {
    initData() {
      let params = {id: this.attendantId};
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_ATTENDANT_AND_CERT_DETAILS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
			this.vueRequest(requestData).then(result => {
        if (result == null) {
          return 
        }
        this.attendantDo = result.data;
      })
    },

    //同步外联平台证书数据
    handleSyncCertData(){
      let params = {attendantId: this.attendantId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SYNC_OCC_CERTIFICATES,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return 
        }
        this.attendantDo.outerPlatformCertificateList = result.data;
        this.$message.success('外联平台证书数据已同步');
        this.handleGetSyncHistory();
      })
    },

    //点击查看同步历史数据触发
     handleSeeSycnHistoyrData() {
       this.handleGetSyncHistory();
    },

    //获取同步历史数据
    handleGetSyncHistory() {
      let params = {attendantId: this.attendantId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_PAGE_CERT_SYNC_HISTORY,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return 
        }
        this.syncHistoryData = result.data;
      })
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    clearData() {
      this.attendantDo = {};
      this.syncHistoryData = [];
    }
  }
}
</script>

<style scoped>
.dialog-attendant /deep/ .el-dialog .el-dialog__header{
  text-align: center;
}

.dialog-attendant /deep/ .el-dialog__header .el-dialog__title{
  color: #5B5B5B;
}

.dialog-attendant /deep/ .el-empty {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/instmng/components/AttendantDetailsDialog.vue